module.exports = __webpack_public_path__ + "img/72600.62041fc5.jpg";